export default __webpack_public_path__ + "82b199464cd9014d5d7ca36e6ee83f4e.woff";